/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */


import { createApp } from "vue";
import axios from 'axios';
import VueAxios from 'vue-axios';
import Noty from 'noty';
import tippy from 'tippy.js';
import 'tippy.js/themes/light.css';
import jquery from 'jquery';
import App from './components/App.vue';
import {Alerts} from './app-noty';
const app = createApp(App)


window.Noty = Noty;
window.Alerts = new Alerts();
window.$ = window.jQuery = jquery;
window.pageWidth = window.innerWidth
window.tippy = tippy;
console.log(window.innerWidth)


import magnific from 'magnific-popup';

app.use(magnific)

import VueTheMask from 'vue-the-mask'
app.use(VueTheMask)

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "noty/src/noty.scss";
import "noty/src/themes/nest.scss";
gsap.registerPlugin(ScrollTrigger);
app.provide("gsap", gsap);

axios.defaults.withCredentials = true;

let token = document.head.querySelector('meta[name="csrf-token"]');
    
// Если не найден в основном документе и мы находимся в iframe, пробуем получить из родительского документа
if (!token && window.self !== window.top) {
    try {
        token = window.parent.document.head.querySelector('meta[name="csrf-token"]');
    } catch (e) {
        console.warn('Cannot access parent document due to cross-origin restrictions');
    }
}

// Если токен найден, устанавливаем его для axios
if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found in current or parent document');
}
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
import { router } from './router'
app.use(router)
import { store } from './storage'
import _ from "lodash";
import moment from 'moment'
window._ = _
window.moment = moment
app.use(store);
app.use(VueAxios,axios)

app.mount('#app')